import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ProductsList from './product-list';
import { Table, Loader, Button } from 'semantic-ui-react';
import AddProduct from '../common/AddProduct/AddProduct';
import LoginButton from '../common/LoginButton';
import GuestUserLoginToast from '../common/GuestUserLoginAlert';
import SubscribeModal from '../common/subscribe_modal/subscribe_modal';
import { handleSeeAllWithSubscription } from '../../common/subscriptionHelper';

const INITIAL_VISIBLE = 5;

const ProductsTab = (props) => {
    const { company, id, products, isCompanyUser, auth, addProducts, history, ShowLogin } = props;
    const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
    const [loading, setLoading] = useState(false);
    const [showLoginAlert, setShowLoginAlert] = useState(false);
    const [showSubscribeModal, setShowSubscribeModal] = useState(false);

    useEffect(() => {
        setVisibleCount(INITIAL_VISIBLE);
    }, [id]);

    const addProductsToList = (addedProducts) => {
        addProducts(id, company.name, addedProducts);
    };

    const refresh_products = () => {
        props.refresh_products();
    };

    const handleMoreClick = () => {
        const totalCount = products?.Items?.length || 0;

        handleSeeAllWithSubscription({
            auth,
            onShowLogin: () => setShowLoginAlert(true),
            onShowSubscribeModal: () => setShowSubscribeModal(true),
            onSubscribed: () => {
                setLoading(true);
                setTimeout(() => {
                    setVisibleCount(totalCount);
                    setLoading(false);
                }, 1000);
            },
        });
    };

    if (!company) {
        return 'Fetching Company Details';
    }

    const productItems = products?.Items || [];
    const hasMore = productItems.length > visibleCount;
    const displayedProducts = productItems.length
        ? { ...products, Items: productItems.slice(0, visibleCount) }
        : products;

    return (
        <div className="supplierslist-wrapper border-1-radius">
            {auth &&
                <AddProduct companyName={company.name} history={history}
                    onSubmit={addProductsToList}
                />
            }
            <div className="supplier-list">
                <Table basic="very">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center">
                                        {company.name} Products
                                    </div>
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    {products && productItems.length > 0
                        ? <Table.Body>
                            <ProductsList
                                products={displayedProducts}
                                isCompanyUser={isCompanyUser}
                                company={company}
                                auth={auth}
                                ShowLogin={ShowLogin}
                                refresh_products={refresh_products}
                            />
                            {hasMore && (
                                <Table.Row>
                                    <Table.Cell colSpan="1" className="text-center">
                                        {auth
                                            ? <Button className="color-light-blue w-100 text-center mt-2 cursor-pointer load_more" onClick={handleMoreClick} loading={loading}>See All</Button>
                                            : <LoginButton />
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                        : products
                            ? <Table.Body>
                                <Table.Row>
                                    <Table.Cell>No products found</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            : <div>
                                Fetching Products
                                <Loader />
                            </div>
                    }
                </Table>
            </div>
            <GuestUserLoginToast {...props} show={showLoginAlert} setStateLoginClose={() => setShowLoginAlert(false)} />
            <SubscribeModal open={showSubscribeModal} onClose={() => setShowSubscribeModal(false)} />
        </div>
    );
};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(ProductsTab);
